import { cx } from '@platform/core/lib/cx';
import type { ISysNoteProps } from './ISysNoteProps';

/**
 * Примітка системної сторінки (прототип v4 custNoRights / grLocked; patterns/scopes-and-permissions): 12px 16px, рамка --line2, радіус 10,
 * тло --surface2; «alert» — жирна (немає прав), «note» — пояснення, чому сторінка лише для читання.
 */
export function SysNote({ children, tone = 'note' }: ISysNoteProps) {
  return <div role={tone === 'alert' ? 'alert' : 'note'} className={cx('sp-note', tone === 'note' && 'sp-note--info')}>{children}</div>;
}
